import { BotDifficulty, RoomState } from "backend/src/common/types/roomState";
import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

export const updateBotDifficulty = (
  botPlayerId: string,
  difficulty: BotDifficulty,
) => {
  const socket = getOrCreateSocket();
  if (store.currentRoom && store.roomState === RoomState.pending) {
    socket.emit(
      "updateBotDifficulty",
      store.currentRoom,
      botPlayerId,
      difficulty,
    );
  }
};
